import { Dtos } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { match } from "ts-pattern";
import { useRequest } from "../../../utils/request";
import { accountQueryKey } from "../../account/account.keys";
import { adminActionItemsQueryKey } from "../../action-item/action-item.keys";
import { adminAgencyPreviewsQueryKey } from "../../agency/agency.keys";
import { bondPreviewsQueryKey, bondQueryKey } from "../../bond/bond.keys";
import {
	bondRequestPreviewsQueryKey,
	bondRequestsQueryKey,
} from "../../bond-request/bond-request.keys";
import { accountPreviewsQueryKey } from "../../previews/previews.keys";

export const useAdminReassignUnderwriter = () => {
	const { post } = useRequest();
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationKey: ["reassignUnderwriter"],
		mutationFn: async (data: Dtos.Admin.UnderwriterAssignment.Assign.Request) =>
			await post(`/v2/admin/underwriter-assignments`, data, "none"),
		onSuccess: (_data, variables, _context) => {
			match(variables)
				.with({ entityType: "agency" }, (_) =>
					queryClient.invalidateQueries({ queryKey: adminAgencyPreviewsQueryKey() }),
				)
				.with({ entityType: "account" }, (e) => {
					queryClient.invalidateQueries({ queryKey: accountQueryKey(e.entityId) });
					queryClient.invalidateQueries({ queryKey: accountPreviewsQueryKey() });
				})
				.with({ entityType: "quote" }, (e) => {
					queryClient.invalidateQueries({ queryKey: bondRequestsQueryKey(e.entityId) });
					queryClient.invalidateQueries({ queryKey: bondRequestPreviewsQueryKey() });
				})
				.with({ entityType: "bond" }, (e) => {
					queryClient.invalidateQueries({ queryKey: bondQueryKey(e.entityId) });
					queryClient.invalidateQueries({ queryKey: bondPreviewsQueryKey() });
				})
				.with({ entityType: "actionItem" }, (_) => {
					queryClient.invalidateQueries({ queryKey: adminActionItemsQueryKey.all() }); // TODO: rework this
				})
				.exhaustive();
		},
	});

	return {
		reassignUnderwriter: mutation.mutate,
		reassignUnderwriterLoading: mutation.isPending,
		reassignUnderwriterSuccess: mutation.isSuccess,
	};
};
